exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading{margin:30px 55px 60px;background:#f1f7f1;border-radius:16px;padding:45px}.loading lottie-player{margin:0 auto 30px;display:block}.loading span{text-align:center;display:inline-block;width:100%;font-size:17px;color:#81858b;font-weight:500;letter-spacing:.016em;margin-left:auto;margin-right:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5e164a00","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true,"data":"@import /"/Users/pola/Documents/udemy/prototype_boxed_layout/src/assets/scss/variables.scss/";"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Loading.vue
// module id = 162
// module chunks = 0